import { h, createRef } from 'preact';
import { PLAYER_EVENT, PLAYER_CONTROL_EVENT } from 'constants/events';
import { AudioAnnotation } from '../audio/index';

export class AudioDescriptionAnnotation extends AudioAnnotation {
    constructor(props) {
        super(props);
        this.el = createRef();
        this.state = {
            muted: true
        };

        this.eventBus.on(PLAYER_CONTROL_EVENT.AUDIO_DESCRIPTIONS_DISABLED, this.handleAudioDescriptionsDisabled);
        this.eventBus.on(PLAYER_CONTROL_EVENT.AUDIO_DESCRIPTIONS_ENABLED, this.handleAudioDescriptionsEnabled);
    }

    handleAudioDescriptionsEnabled = () => {
        this.setState({
            muted: false
        })
    }

    handleAudioDescriptionsDisabled = () => {
        this.setState({
            muted: true
        });
    }

    componentWillUnmount() {
        this.eventBus.off(PLAYER_CONTROL_EVENT.AUDIO_DESCRIPTIONS_DISABLED, this.handleAudioDescriptionsDisabled);
        this.eventBus.off(PLAYER_CONTROL_EVENT.AUDIO_DESCRIPTIONS_ENABLED, this.handleAudioDescriptionsEnabled);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.content !== this.props.content) {
            if (this.state.playing === true) {
                const el = this.el.current;
                el.play();
                el.currentTime = this.props.currentTime;
            }
        }
    }

    render() {
        const { muted, volume } = this.state;

        return (
            <audio src={this.contents} ref={this.el} muted={muted} volume={volume}/>
        )
    }
}